// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c72a88c9","171":"fc7cc8da","494":"6208a46e","695":"0bd81cb6","751":"feb4cab8","919":"ad1300ae","935":"537e36f8"}[chunkId] + ".chunk.js";
};